import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ClipboardPencil = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.969 43.045l-8.253-8.25a1.227 1.227 0 00-1.738 0l-22.583 22.58.045.045-.072-.02-3.091 11.534.009.002a1.21 1.21 0 001.669 1.486l.002.009 11.415-3.059-.007-.027.019.019 22.584-22.583a1.23 1.23 0 00.001-1.736zM56.035 66.697l1.836-6.846 5.012 5.012-6.848 1.834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.967 73.23h-7.485a1.23 1.23 0 00-1.228 1.229l.002.012v8.715H21.612V21.809h4.997v3.069c-.002.033-.01.063-.01.097 0 .998.81 1.814 1.814 1.814l.014-.001v.008h28.027a1.815 1.815 0 001.813-1.813c0-.015-.004-.029-.004-.044v-3.13h4.992v8.718l-.002.012a1.227 1.227 0 001.228 1.229h7.485a1.229 1.229 0 001.228-1.228V17.26h-.019c.001-.049.015-.095.015-.145a5.245 5.245 0 00-5.241-5.245c-.04 0-.076.011-.116.012H53.276V8.478c0-.881-.714-1.593-1.593-1.595v-.008h-18.45v.006c-.015 0-.028-.004-.043-.004-.88 0-1.594.713-1.594 1.594l.003.03v3.38H16.935l-.02-.002a5.248 5.248 0 00-5.242 5.243c0 .047.013.09.014.137h-.014v70.572h.003l-.003.027a5.24 5.24 0 005.243 5.238c.078 0 .151-.02.229-.023v.021h50.5c.098.005.191.029.29.029a5.24 5.24 0 005.239-5.238c0-.019-.005-.036-.005-.055h.028V74.458a1.229 1.229 0 00-1.23-1.228z"
  }));
});
ClipboardPencil.displayName = 'ClipboardPencil';
export var ClipboardPencilDimensions = {
  height: 100,
  width: 100
};